import { submitInternalEventAndRedirectToPage as s } from "../../../shared/data/tracking/utilities/index.js";
import "../../../shared/data/tracking/types/index.js";
import { Link as n } from "./index3.js";
import { useNavigationEventBus as r } from "@ado/acs-standard-library";
class h extends n {
  title;
  target;
  navigationEventBus;
  eventData;
  constructor(t, e = "", i = !1, a) {
    super(t.isVisible, t.value), this.title = e ?? "", this.target = i ?? !1 ? "_blank" : "_self", this.navigationEventBus = a ?? r();
  }
  addTracking(t) {
    return this.eventData = t, this;
  }
  open = () => {
    this.eventData === void 0 ? this.navigationEventBus.navigate(this.value, this.target) : s(
      this.eventData,
      {
        url: this.value,
        target: this.target
      },
      this.navigationEventBus
    );
  };
}
export {
  h as FullLink
};
//# sourceMappingURL=index6.js.map
